import { render, staticRenderFns } from "./communicationDashboardPopupsNew.vue?vue&type=template&id=2823759a&scoped=true"
import script from "./communicationDashboardPopupsNew.vue?vue&type=script&lang=js"
export * from "./communicationDashboardPopupsNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2823759a",
  null
  
)

export default component.exports